import { WidgetUIType } from './widget.type';

export class WidgetModel {
  constructor(public widgetUIType: WidgetUIType, public selecedViewId: string) {}
}
